import { useGetFaq } from "@/components/parts/admin/website-management/faq/api";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import React from "react";

export default function FaqSection() {
  const { data } = useGetFaq("limit=9999");
  const detail = data?.data.items;

  return (
    <section className="bg-primary-100 py-10">
      <h1 className="text-center font-semibold">FAQ</h1>

      <Accordion type="single" collapsible className="container">
        {detail?.map((item, i) => (
          <AccordionItem
            value={item.question}
            key={i}
            className="border-b-2 border-gray-400"
          >
            <AccordionTrigger className="font-medium text-xl">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="font-normal text-lg">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
